<template>
  <div class="service-page">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <span class="nav-back" @click="$router.back()">
        <i class="el-icon-arrow-left"></i>
      </span>
      <span class="nav-title">客服中心</span>
    </div>

    <!-- 内容区 -->
    <div class="content">
      <!-- 引号装饰 + 服务承诺 -->
      <div class="slogan-area">
        <span class="quote quote-left">"</span>
        <p class="slogan-text">客服24小时<br/>竭诚为您服务</p>
        <span class="quote quote-right">"</span>
      </div>

      <!-- 服务热线 -->
      <div class="hotline-area">
        <p class="hotline-label">服务热线：</p>
        <a class="hotline-number" href="tel:400-7656899">400-7656899</a>
      </div>

      <!-- 联系客服按钮 -->
      <button class="contact-btn" @click="handleContact">
        联系客服
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceCenter',
  methods: {
    handleContact() {
      window.location.href = 'tel:400-7656899'
    }
  }
}
</script>

<style scoped>
.service-page {
  min-height: 100vh;
  background: linear-gradient(160deg, #5edcc4 0%, #4ecdc4 40%, #a8e6cf 80%, #d4f1e0 100%);
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  position: relative;
  flex-shrink: 0;
}

.nav-back {
  position: absolute;
  left: 12px;
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  padding: 4px;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

/* 内容区 */
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 32px 120px;
}

/* 引号装饰 + 服务承诺 */
.slogan-area {
  position: relative;
  text-align: center;
  margin-bottom: 36px;
  padding: 0 20px;
}

.quote {
  position: absolute;
  font-size: 60px;
  color: rgba(255, 255, 255, 0.6);
  font-family: Georgia, serif;
  line-height: 1;
}

.quote-left {
  top: -20px;
  left: -8px;
}

.quote-right {
  bottom: -30px;
  right: -8px;
}

.slogan-text {
  font-size: 18px;
  color: #fff;
  line-height: 1.8;
  font-weight: 500;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* 服务热线 */
.hotline-area {
  text-align: center;
  margin-bottom: 40px;
}

.hotline-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 6px;
}

.hotline-number {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  text-decoration: none;
  display: inline-block;
}

/* 联系客服按钮 */
.contact-btn {
  width: 65%;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: #3cbaa8;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 14px rgba(60, 186, 168, 0.35);
}

.contact-btn:active {
  transform: scale(0.97);
  opacity: 0.9;
}
</style>
